var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconattachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2688 4.74991L4.76057 11.3662C4.52616 11.6006 4.39447 11.9186 4.39447 12.2501C4.39447 12.5816 4.52616 12.8995 4.76057 13.134C4.99499 13.3684 5.31292 13.5001 5.64444 13.5001C5.97595 13.5001 6.29388 13.3684 6.5283 13.134L14.2865 5.26766C14.5187 5.03552 14.7028 4.75993 14.8284 4.45662C14.9541 4.15331 15.0187 3.82823 15.0187 3.49994C15.0187 3.17164 14.9541 2.84656 14.8284 2.54325C14.7028 2.23995 14.5187 1.96435 14.2865 1.73221C14.0544 1.50007 13.7788 1.31593 13.4755 1.1903C13.1722 1.06466 12.8471 1 12.5188 1C12.1905 1 11.8654 1.06466 11.5621 1.1903C11.2588 1.31593 10.9832 1.50007 10.7511 1.73221L2.99285 9.59851C2.28961 10.3018 1.89453 11.2556 1.89453 12.2501C1.89453 13.2446 2.28961 14.1984 2.99285 14.9017C3.6961 15.6049 4.6499 16 5.64444 16C6.63897 16 7.59278 15.6049 8.29602 14.9017L14.7062 8.49981",
    stroke: "#969696",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconattachment);
export default __webpack_public_path__ + "static/media/icon.attachment.e2ace3236bd8142b5bcda201fd0957c2.svg";
export { ForwardRef as ReactComponent };